export default "__VITE_ASSET__9fd477d6__"